import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/phone-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-1e6c56e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xhy-autograph-box" }
const _hoisted_2 = { class: "popup-box van-hairline--surround" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-full-tip" }, [
  /*#__PURE__*/_createElementVNode("span", null, "请旋转手机至横屏"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "phone-icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("span", null, ",在上方空白区域签字")
], -1))
const _hoisted_4 = { class: "xhy-canvasFull" }

import { computed, defineComponent, watch, getCurrentInstance, onMounted, reactive, toRefs } from 'vue';
import SignaturePad from 'signature_pad';
import { Toast } from 'vant';
    // 父组件传值
    
export default /*#__PURE__*/_defineComponent({
  props: {
        /**
         * 参数值
         * @protected
         * @returns Object
         */
        config:{
            type: Object,
            default: {
                penColor: 'green', //笔刷颜色
                minWidth: 1 //最小宽度
            }
        }
    },
  emits: ["receive"],
  setup(__props, { expose, emit }) {

const props = __props



    

    let state = reactive({
        signaturePad: null, // 存放竖屏SignaturePad对象
        signaturePadFull: null, // 存放横屏SignaturePad对象
        value: '',
        fullValue: '',
        isMove: false
    })

    function onAutographTouchmove()
    {
        state.isMove = true;
    }

    // 初始化签名面板
    const initFull = () => {
        if (!state.signaturePadFull) {
            let canvas = document.querySelector('.autograph-canvas');
            let canvasBox = document.querySelector('.xhy-canvasFull');
            state.signaturePadFull = new SignaturePad((canvas as HTMLCanvasElement), props.config);
            (canvas as any).height =canvasBox.clientHeight;
            (canvas as any).width = canvasBox.clientWidth - 20;
        }
    }

    // 清楚面板
    const againFull = () => {
        state.isMove=false;
        // initFull();
        state.signaturePadFull.clear();
    }
    
    // 确认签名
    const confirmFull = () => {
        try {
            let _flag = state.signaturePadFull.isEmpty();
            // state.signaturePadFull.clear();
            if (!_flag) {
                state.fullValue = state.signaturePadFull.toDataURL();
                let canvasBox = document.querySelector('.xhy-canvasFull');
               
                rotateBase64Img(state.fullValue, 270, res => {
                    let _option = {
                        width: canvasBox.clientWidth - 20,
                        height: canvasBox.clientHeight
                    }
                    state.signaturePadFull.fromDataURL(res, _option);
                    state.signaturePadFull.clear();
                    emit('receive', res); //通知父组件改变。
                })
            }
            else
            {
                Toast("请先完成签名!");
            }
        } catch (error) {
            console.log(error)
        }
    }

    // base64图片旋转方法
    const rotateBase64Img = (src, edg, callback) => {
        var canvas = document.createElement("canvas");
        console.log(canvas)
        var ctx = canvas.getContext("2d");
        var imgW; //图片宽度
        var imgH; //图片高度
        var size; //canvas初始大小
        if (edg % 90 != 0) {
            console.error("旋转角度必须是90的倍数!");
            throw '旋转角度必须是90的倍数!';
        }
        (edg < 0) && (edg = (edg % 360) + 360)
        const quadrant = (edg / 90) % 4; //旋转象限
        const cutCoor = {
            sx: 0,
            sy: 0,
            ex: 0,
            ey: 0
        }; //裁剪坐标
        var image = new Image();
        image.crossOrigin = "anonymous"
        image.src = src;
        image.onload = function () {
            imgW = image.width;
            imgH = image.height;
            size = imgW > imgH ? imgW : imgH;
            canvas.width = size * 2;
            canvas.height = size * 2;
            switch (quadrant) {
                case 0:
                    cutCoor.sx = size;
                    cutCoor.sy = size;
                    cutCoor.ex = size + imgW;
                    cutCoor.ey = size + imgH;
                    break;
                case 1:
                    cutCoor.sx = size - imgH;
                    cutCoor.sy = size;
                    cutCoor.ex = size;
                    cutCoor.ey = size + imgW;
                    break;
                case 2:
                    cutCoor.sx = size - imgW;
                    cutCoor.sy = size - imgH;
                    cutCoor.ex = size;
                    cutCoor.ey = size;
                    break;
                case 3:
                    cutCoor.sx = size;
                    cutCoor.sy = size - imgW;
                    cutCoor.ex = size + imgH;
                    cutCoor.ey = size + imgW;
                    break;
            }
            ctx.translate(size, size);
            ctx.rotate(edg * Math.PI / 180);
            ctx.drawImage(image, 0, 0);
            var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
            if (quadrant % 2 == 0) {
                canvas.width = imgW;
                canvas.height = imgH;
            } else {
                canvas.width = imgH;
                canvas.height = imgW;
            }
            ctx.putImageData(imgData, 0, 0);
            callback(canvas.toDataURL())
        }
    }

    onMounted(()=>
    {
        initFull();
    })

    expose({againFull});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "panel-full" }, [
        _hoisted_3,
        _createElementVNode("div", { class: "panel-full-btn" }, [
          _createElementVNode("button", {
            class: "btn-again",
            onClick: againFull
          }, "清空"),
          _createElementVNode("button", {
            class: "sign-btn",
            onClick: confirmFull
          }, "签字完毕")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("canvas", {
          class: _normalizeClass(["autograph-canvas", {bg:!_unref(state).isMove}]),
          onTouchstart: onAutographTouchmove
        }, null, 34)
      ])
    ])
  ]))
}
}

})